import { AngularEnvironment } from './angular-environment';

export const environment: AngularEnvironment = {
	name: 'DEV',
	appName: 'Programs',
	baseUrl: 'https://programs-dev.eforall.org/',
	bodyCssClasses: ['dev-grey'],
	frame: 'Dashboard',
	supportsSpanish: false,
	functionUrl: "https://us-central1-eforall-programs-dev.cloudfunctions.net/",
	firebaseConfig: {
		apiKey: "AIzaSyArS7z7N3XF34bVSNdCwnGCAqct4PDar2g",
		authDomain: "eforall-programs-dev.firebaseapp.com",
		projectId: "eforall-programs-dev",
		storageBucket: "eforall-programs-dev.firebasestorage.app",
		messagingSenderId: "635240094803",
		appId: "1:635240094803:web:77b0ee0a235d95e177faa6",
		measurementId: "G-0EY6ZKTVGS"
	},
	algoliaConfig: {
		applicationId: 'IBESBT489G',
		apiKey: '69bbe063ee0e4d3664ac9ac7ffd0fc37',
		indexName: 'prod_PROGRAMS_APP'
	},
};
